import React, { useCallback, useEffect, useMemo } from "react";
import Modal from "react-bootstrap/Modal";
import { useWallet } from "@providers/wallet.provider";
import ConnectItem from "../ConnectItem";
import useModal from "@hooks/ModalHook";
import { SUPPORTED_WALLETS } from "@configCustom/wallet.config";
import { WalletType } from "@goblinhunt/cosmes/wallet";

type WalletSupport = {
  id?: string | number;
  name: string;
  type: WalletType;
  walletName: string;
};

function WalletModal() {
  const { address, connect } = useWallet();
  const { showModal, closeModal, modalId } = useModal();

  const open = showModal && modalId === "wallet";
  const wallets = useMemo(
    () => SUPPORTED_WALLETS as unknown as WalletSupport[],
    []
  );

  useEffect(() => {
    if (open && address) closeModal();
  }, [open, address, closeModal]);

  return (
    <Modal
      key={open ? "wallet-open" : "wallet-closed"}
      show={open}
      onHide={closeModal}
      restoreFocus
      enforceFocus
      backdrop
      keyboard
      dialogClassName="max-w-lg"
    >
      {/* Tombol close bawaan (ikon X di kanan atas) */}
      <Modal.Header closeButton>
        <Modal.Title>Connect your wallet</Modal.Title>
        <button
          type="button"
          className="btn-close"
          onClick={closeModal}
          aria-label="Close"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
            className="h-6 w-6 fill-jacarta-700 dark:fill-white"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
          </svg>
        </button>
      </Modal.Header>

      <Modal.Body className="grid grid-cols-2 gap-3 p-6 text-center">
        {SUPPORTED_WALLETS.map((e, index) => (
          <div
            onClick={() => {
              connect(e).then(() => {
                closeModal();
              });
            }}
            className="grid cursor-pointer grid-cols-4 rounded-2.5xl border border-jacarta-100 bg-white px-7 py-4 transition-shadow hover:shadow-lg dark:border-transparent dark:bg-jacarta-700"
          >
            <figure className="mr-4 shrink-0">
              <img
                src={`/src/img/wallets/${e.walletName.toLowerCase()}.png`}
                width="50"
                height="50"
                alt="wallet icon"
                className="rounded-2lg"
                loading="lazy"
              />
            </figure>
            <div className="col-span-3 text-start">
              <p className="font-display font-semibold text-jacarta-700 hover:text-accent dark:text-white">
                {e.name}
              </p>
              <p className="text-sm dark:text-jacarta-300">{e.type}</p>
            </div>
          </div>
        ))}
      </Modal.Body>
    </Modal>
  );
}

export default WalletModal;
